module.exports = __webpack_public_path__ + "assets/images/fruits_r.5e5528fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/risks/fruits_r.png
// module id = 712
// module chunks = 1